import { formatDuration, formatNumber, PHASES } from './shared';

/*
 * Journal des étapes terminées, avec leur durée : c'est ce qui permet de juger si une
 * opération avance normalement ou si une étape sort de l'ordinaire.
 */
const StepLog = ({ steps }) => (
  <div style={{ fontFamily: 'monospace', fontSize: 12, maxHeight: 240, overflowY: 'auto' }}>
    {steps.map((step, index) => (
      <div key={`${step.label}-${index}`} style={{ display: 'flex', gap: 16, justifyContent: 'space-between', padding: '1px 0' }}>
        <span>
          {PHASES[step.phase] || step.phase} · {step.label}
        </span>
        <span style={{ color: '#888', whiteSpace: 'nowrap' }}>
          {formatNumber(step.done)}
          {step.expected !== undefined ? ` / ${formatNumber(step.expected)}` : ''} — {formatDuration(step.durationMs)}
        </span>
      </div>
    ))}
  </div>
);

export default StepLog;
